const initState = {
	notification: [],
	recent_notification: [],
	total_pages: 0,
	total_unread_counts: 0,
};

export const notificationReducer = (state = initState, action) => {
	switch (action.type) {
		case 'initialize_notification':
			return {
				...state,
				notification: action.payload.notifications,
				total_pages: action.payload.total_pages,
				total_unread_counts: action.payload.total_unread_counts,
			};
		case 'update_notification':
			return {
				...state,
				notification: [...action.payload.notifications, ...state.notification],
				recent_notification: action.payload.recent_notification,
				total_unread_counts: state.total_unread_counts + Number(action.payload.total_unread_counts),
			};
		case 'update_recent_notification':
			const recentNotificationData = state.recent_notification.map((item) => {
				if (action.payload.ids.includes(item.id)) {
					return { ...item, is_read: true };
				}
				return item;
			});
			const notificationData = state.notification.map((item) => {
				if (action.payload.ids.includes(item.id)) {
					return { ...item, is_read: true };
				}
				return item;
			});
			const recentNotificationList =
				action.payload.ids === undefined
					? action.payload.recent_notification
					: recentNotificationData;
			const notificationList =
				action.payload.ids === undefined ? action.payload.recent_notification : notificationData;
			return {
				...state,
				recent_notification: recentNotificationList,
				notification: notificationList,
				total_unread_counts:
					action.payload.ids === undefined
						? action.payload.total_unread_counts
						: state.total_unread_counts - Number(action.payload.ids.length),
			};
		case 'clear_notification':
			return {
				notification: [],
				recent_notification: [],
				total_pages: 0,
				total_unread_counts: 0,
			};

		default:
			return state;
	}
};
